export const GTM_EVENTS = {
  CTA_CLICK: 'cta_click',
  PAGE_VIEW: 'page_view',
  SEARCH: 'search',
  ADD_TO_CART: 'add_to_cart',
};

export const GTM_CONSTS = {
  EUROPE_OPERATIONS: 'Europe Operations',
  PAGE_CATEGORY_HOME: 'Home',
};
